import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { SkeletonLoginScreen } from 'structure/login/loading-screen';
import { loginModuleQuery } from 'system/structure-modules';

export function SuspenseFallback() {
    return <SkeletonLoginScreen />;
}

export default function LoginLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/login/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'login',
        instanceKey: 'one',
        moduleQuery: loginModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig} loadingScreen={<SkeletonLoginScreen />}>
            <InstanceStack screenOptions={{ headerRight: () => null }} />
        </DatastoreProvider>
    );
}
